
import { useState, useEffect } from "react";
import { getAuthHeader } from "@/services/authService";

export interface ToolUsageStats {
  toolName: string;
  totalUsage: number;
  postEmbeds: number;
  lastUsed?: string;
}

export const useToolUsageStats = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [toolUsageStats, setToolUsageStats] = useState<ToolUsageStats[]>([]);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchToolStats = async () => {
      try {
        const response = await fetch("/api/admin/tool-usage-stats", {
          headers: {
            ...getAuthHeader(),
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch tool usage stats");
        }

        const stats = (await response.json()) as ToolUsageStats[];
        setToolUsageStats(stats);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching tool stats:", error);
        setError(error instanceof Error ? error : new Error('Unknown error'));
        setIsLoading(false);
      }
    };

    fetchToolStats();
  }, []);

  return { isLoading, toolUsageStats, error };
};
